import React, { useState, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import '../../styles/signIn.scss';

const SignIn = () => {
  const { signIn, requestPasswordReset } = useContext(AuthContext);
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setError('');
    setNotice('');
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await signIn(formData.email, formData.password);
      // On success, AuthContext's onAuthStateChange swaps the view automatically.
    } catch (err) {
      setError('Invalid email or password.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    setError('');
    setNotice('');
    if (!formData.email) {
      setError('Enter your email above first, then click "Forgot password?".');
      return;
    }
    try {
      await requestPasswordReset(formData.email);
      setNotice('If that email exists, a password reset link has been sent.');
    } catch (err) {
      setError('Could not send the reset email. Please try again.');
      console.error(err);
    }
  };

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={handleSubmit}>
        <h1>Mangone Law Firm</h1>
        <h2>Sign in</h2>

        <div className="auth-input-container">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            name="email"
            placeholder="you@mangonelawfirmllc.com"
            value={formData.email}
            onChange={handleChange}
            autoComplete="username"
            required
          />
        </div>

        <div className="auth-input-container">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            autoComplete="current-password"
            required
          />
        </div>

        {error && <span className="auth-error">{error}</span>}
        {notice && <span className="auth-notice">{notice}</span>}

        <button className="auth-submit" type="submit" disabled={loading}>
          {loading ? 'Signing in...' : 'Sign in'}
        </button>

        <button
          className="auth-link"
          type="button"
          onClick={handleForgotPassword}
        >
          Forgot password?
        </button>
      </form>
    </div>
  );
};

export default SignIn;
